import { getWCScriptURL, getWCStyleURL, SHADOW_DOM_ENABLED } from "../src/constants/wcConstants";
import { cleanElementId, loadScript, loadStyle } from "../src/utilities/utils";
const getWCComponent = (WebComponentName, ObservedAttributes = []) => {
    const EZComponent = class extends HTMLElement {
        constructor() {
            super();
            //END : Built-In Methods
            this.buildContainer = () => {
                const wcContainer = document.createElement('div');
                if (this.useShadowDOM) {
                    this.attachShadow({ mode: 'open' });
                }
                wcContainer.setAttribute('data-wc-id', WebComponentName);
                this.rootElement.appendChild(wcContainer);
            };
        }
        //START : Built-In Methods
        connectedCallback() {
            this.buildContainer();
            loadStyle(cleanElementId(`${WebComponentName}-css`), getWCStyleURL(WebComponentName), this.rootElement);
            loadScript(cleanElementId(`${WebComponentName}-js`), getWCScriptURL(WebComponentName), this.rootElement);
            this.setAttribute(`data-ez-wc-name`, WebComponentName === null || WebComponentName === void 0 ? void 0 : WebComponentName.replace('ez-', ''));
        }
        disconnectedCallback() { }
        attributeChangedCallback(name) {
            window.dispatchEvent(new CustomEvent('ATTRIBUTE_CHANGED_EVENT', {}));
        }
        static get observedAttributes() {
            return ObservedAttributes;
        }
        get rootElement() {
            return this.useShadowDOM ? this.shadowRoot : this;
        }
        get useShadowDOM() {
            return SHADOW_DOM_ENABLED;
        }
    };
    return EZComponent;
};
export default getWCComponent;
